import { useCallback, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { api } from '../lib/api.js'
import { DataTable } from '../components/DataTable.jsx'

const fmtDate = (v) => (v ? new Date(v).toLocaleDateString('tr-TR') : '-')

export function UserDetail() {
  const { id } = useParams()
  const [user, setUser] = useState(null)
  const [error, setError] = useState(null)
  const [saving, setSaving] = useState(false)

  const load = useCallback(() => {
    api(`/admin/users/${id}`)
      .then((r) => setUser(r.data))
      .catch((e) => setError(e.message))
  }, [id])

  useEffect(load, [load])

  async function update(patch) {
    setSaving(true)
    setError(null)
    try {
      await api(`/admin/users/${id}`, { method: 'PATCH', body: patch })
      load()
    } catch (e) {
      setError(e.message)
    } finally {
      setSaving(false)
    }
  }

  if (error) return <div className="alert">{error}</div>
  if (!user) return <div className="muted">Yukleniyor...</div>

  return (
    <>
      <Link className="back" to="/users">
        &larr; Kullanicilar
      </Link>
      <h1>{user.full_name}</h1>

      <div className="card">
        <dl className="detail">
          <dt>E-posta</dt>
          <dd>{user.email}</dd>
          <dt>Kayit</dt>
          <dd>{fmtDate(user.created_at)}</dd>
          <dt>Son giris</dt>
          <dd>{fmtDate(user.last_login_at)}</dd>
          <dt>Rol</dt>
          <dd>
            <select
              value={user.role}
              disabled={saving}
              onChange={(e) => update({ role: e.target.value })}
            >
              <option value="parent">parent</option>
              <option value="staff">staff</option>
              <option value="admin">admin</option>
            </select>
          </dd>
          <dt>Durum</dt>
          <dd>
            <select
              value={user.status}
              disabled={saving}
              onChange={(e) => update({ status: e.target.value })}
            >
              <option value="active">active</option>
              <option value="suspended">suspended</option>
            </select>
          </dd>
        </dl>
      </div>

      <div className="card">
        <h2>Cocuklar</h2>
        <DataTable
          empty="Bu kullaniciya ait cocuk kaydi yok"
          rows={user.children}
          columns={[
            { key: 'full_name', label: 'Ad' },
            { key: 'sex', label: 'Cinsiyet' },
            { key: 'birth_date', label: 'Dogum', render: (c) => fmtDate(c.birth_date) },
            { key: 'measurement_count', label: 'Olcum' },
          ]}
        />
      </div>
    </>
  )
}
